export const prepareTaxValue = value => '£' + value;
